import { hasStoredPasskey } from '../webauthn'
import { evaluateDeviceAuthPolicy } from './policy'
import {
    clearDeviceAuthAttempted,
    clearDeviceAuthSession,
    getDeviceAuthAttempted,
    getDeviceAuthVerified,
    getLastDeviceAuthActivityTs,
    setDeviceAuthAttempted,
    setDeviceAuthVerified,
    touchDeviceAuthActivity,
} from './storage'

export type DeviceAuthPolicySnapshot = {
    hasStoredPasskey: boolean
    verified: boolean
    attempted: boolean
    lastActivityTs: number | null
}

export function readDeviceAuthSnapshot(): DeviceAuthPolicySnapshot {
    return {
        hasStoredPasskey: hasStoredPasskey(),
        verified: getDeviceAuthVerified(),
        attempted: getDeviceAuthAttempted(),
        lastActivityTs: getLastDeviceAuthActivityTs(),
    }
}

export function resolveDeviceAuthRequirement(inactivityMs: number) {
    const snapshot = readDeviceAuthSnapshot()
    const decision = evaluateDeviceAuthPolicy({
        hasStoredPasskey: snapshot.hasStoredPasskey,
        verified: snapshot.verified,
        attempted: snapshot.attempted,
        lastActivityTs: snapshot.lastActivityTs,
        inactivityMs,
    })

    if (decision.clearExpiredSession) {
        clearDeviceAuthSession()
        return { shouldPrompt: true, reason: 'expired-session-cleared', snapshot: readDeviceAuthSnapshot() }
    }

    if (decision.skipAuth) {
        return { shouldPrompt: false, reason: 'policy-skip', snapshot }
    }

    return { shouldPrompt: true, reason: 'policy-requires-auth', snapshot }
}

export function persistDeviceAuthSuccess() {
    setDeviceAuthVerified()
    touchDeviceAuthActivity()
    clearDeviceAuthAttempted()
}

export function persistDeviceAuthFailureAttempt() {
    if (hasStoredPasskey()) {
        setDeviceAuthAttempted()
    }
}

export function persistDeviceAuthSignedOut() {
    clearDeviceAuthSession()
}
